import React, { useEffect, Suspense } from "react";
import Page1 from "./pages/Page1";
import ReactGA from "react-ga4";

// Lazy import pages AFTER all normal imports
const Page2 = React.lazy(() => import("./pages/Page2"));
const Page3 = React.lazy(() => import("./pages/Page3"));
const Page4 = React.lazy(() => import("./pages/Page4"));

ReactGA.initialize("G-7LJ1EL52S3");

function App() {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  return (
    <div className="App">
      {/* Indexable SEO page */}
      <Page1 />

      {/* Non-indexable sections */}
      <Suspense fallback={<div></div>}>
        <section id="page2" data-nosnippet data-googlebot="noindex">
          <Page2 />
        </section>

        <section id="page3" data-nosnippet data-googlebot="noindex">
          <Page3 />
        </section>

        <section id="page4" data-nosnippet data-googlebot="noindex">
          <Page4 />
        </section>
      </Suspense>
    </div>
  );
}

export default App;
